import type { ButtonSize } from '@sunwebgroup/ui-components';
import { Banner, Typography, tk, Button, SpaceBetween } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { useIntl } from '@/intl';

export const GroupLink = () => {
  const intl = useIntl();
  return (
    <ParticipantsBanner
      link={{
        href: '/vakantie/groepsreizen',
        size: 'small',
        text: intl.formatMessage({ id: 'quicksearch_filter_participants_group_travel_link_text' }),
      }}
      text={intl.formatMessage({ id: 'quicksearch_filter_participants_group_travel_description' }, { groupSize: 20 })}
    />
  );
};

export const ChildInfo = () => {
  const intl = useIntl();
  return <ParticipantsBanner text={intl.formatMessage({ id: 'quicksearch_filter_participants_description' })} />;
};

export const ChildWithoutAdultRoomInfo = () => {
  const intl = useIntl();
  return (
    <ParticipantsBanner
      text={intl.formatMessage({ id: 'quicksearch_filter_participants_room_no_adults_description' })}
    />
  );
};

const ParticipantsBanner = ({
  link,
  text,
}: {
  link?: {
    href: string;
    size: ButtonSize;
    text: string;
  };
  text: string;
}) => {
  return (
    <BannerWrapper>
      <Banner $type="info">
        <Texts direction="y">{text && <Typography $variant="body-sm">{text}</Typography>}</Texts>
        {link && (
          <Button $hierarchy="tertiary" $size={link.size} $withoutColor href={link.href} as="a">
            {link.text}
          </Button>
        )}
      </Banner>
    </BannerWrapper>
  );
};

const BannerWrapper = styled.div`
  width: 85%;
  margin: auto;
  margin-bottom: ${tk('spacing_sm')};
`;

const Texts = styled(SpaceBetween)`
  flex: 1;
`;
